"use client"

import { StytchProvider } from "@stytch/nextjs"
import { createStytchUIClient } from "@stytch/nextjs/ui"
import { ReactNode } from "react"

// Optional object for configuring SDK cookie behavior, currently showing defaults
const stytchOptions = {
    cookieOptions: {
        opaqueTokenCookieName: "stytch_session",
        jwtCookieName: "stytch_session_jwt",
        path: "/",
        availableToSubdomains: false,
        domain: ""
    }
}

const stytchClient = createStytchUIClient(process.env.NEXT_PUBLIC_STYTCH_PUBLIC_TOKEN || "", stytchOptions)

export function StytchClientProvider({ children }: { children: ReactNode }) {
    return <StytchProvider stytch={stytchClient}>{children}</StytchProvider>
}
